import React, { Component } from 'react';
import gripList from '../../data/grip';
import ReactGA from 'react-ga';
import KickstarterBanner from './KickstarterBanner';

class Kickstarter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      title: 'Kickstarter X HALASZ',
      contents: '',
      mailSent: false,
      error: null,
      gripData: gripList,
      isShow: false,
    };
  }

  render() {
    ReactGA.pageview(window.location.pathname + window.location.search);

    return (
      <main className={'grip-page'}>
        <KickstarterBanner />

        <section className="service-area relative mt-50 mb-50">
          <div className="container">
            <div className={'title'}>APP</div>
            <div className="row align-items-start">
              <div className="col-lg-6">
                <div className={'sub-title'}>What is HALASZ APP?</div>
                <div className={'left-content'}>
                  'Halasz App' is a new platform that provides information about fishing around the world vy hosting and participating
                  online fishing tournaments using Halasz Fishing Grip.
                </div>
                <div className={'left-content'}>
                  When you take a photo on the Halasz App, you will automatically be provided with a photo showing the measurement
                  information and fishing information such as date, weather, location, etc.
                </div>
                <div className={'left-content'}>
                  With the photos, you can post it on the Halasz App as well as on personal SNS, and partipate in online fishing tournaments
                  shown in the Halasz App.
                </div>
                <div className={'row left'}>
                  <img
                    className="img-fluid "
                    style={{ width: '44%' }}
                    src={require('../../assets/img/kickstarter/halasz_fishinf_app_mockup.png')}
                    alt=""
                  />
                  <div style={{ marginTop: '200px', marginLeft: '20px' }}>
                    <img className="playstore-btns" src={require('../../assets/img/kickstarter/halasz_fishing_store_google.png')} alt="" />
                    <br />
                    <img className="playstore-btns" src={require('../../assets/img/kickstarter/halasz_fishing_store_apple.png')} alt="" />
                  </div>
                </div>
              </div>

              <div className="col-lg-6 " style={{ borderLeft: '1px solid #eff0ef', paddingLeft: '30px' }}>
                <div className={'sub-title'}>System Service Features</div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_display.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>AUTOMATIC DISPLAY PHOTO</div>
                    <div>Automatically Displays Measurement Information and Fishing Information</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_entry.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>AUTOMATIC ENTRY</div>
                    <div>Automatically Type In Information Based on Provided Photo</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_feed.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>CREATE PERSONAL FEED</div>
                    <div>Upload the Provided Photo and Create Own Personal Catch Feed</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_communicate.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>COMMUNICATE WITH OTHER ANGLERS</div>
                    <div>Like and Follow Other Angler, Make and Join Clan, Compete Each Other</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_tournament.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>ONLINE FISHING TOURNAMENT</div>
                    <div>Upload the Provided Photo and Participate on Tournaments</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_rankingbased.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>RANKING BASED ON WEIGHT, LENGTH, SPECIES, ETC.</div>
                    <div>With Halasz Products, Ranking Determinable Based on Weight, Length, Species, Etc.</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fifshing_ico_leaderboard.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>AUTOMATIC FINAL LEADERBOARD</div>
                    <div>Automatic Ranking Calulation After Uploading Provided photo</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container" style={{ paddingTop: '100px', marginBottom: '100px' }}>
            <div className={'title'}>PRODUCT</div>
            <div className="row align-items-start">
              <div className="col-lg-6">
                <div className={'sub-title'}>What is HALASZ FISHING GRIP?</div>
                <div className={'left-content'}>
                  'Halasz Fishing Grip' is an IoT fishing grip that can measure the length and the weight of the caught fish at the same
                  time.
                </div>
                <div className={'left-content'}>
                  By BLE, the measurements are shown not only on the product LCD screen but also on HALASZ APP.
                </div>

                <div className={'row left'}>
                  <img
                    className="img-fluid "
                    style={{ width: '80%' }}
                    src={require('../../assets/img/kickstarter/halasz_fishing_grip.png')}
                    alt=""
                  />
                </div>
              </div>

              <div className="col-lg-6 " style={{ borderLeft: '1px solid #eff0ef', paddingLeft: '30px' }}>
                <div className={'sub-title'}>Product Service Features</div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_measurement.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>REAL-TIME MEASUREMENT</div>
                    <div>Both Weight and Length</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_bluetooth.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>BLUETOOTH</div>
                    <div>Concurrent Display on Both LCD Screen and HALASZ APP</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_unit.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>MEASUREMENT UNIT SETTING</div>
                    <div>Easy Unit Conversion</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_photo.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>FISHING INFORMATION PHOTO</div>
                    <div>Fishing Information (Data, Weather, Location, etc.) Displayed</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_strong.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>STRONG DURABILITY</div>
                    <div>Drop-test, Dust-proof, Water-proof Passed</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_fish.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>UNRESTRICTED SPECIES OF FISH</div>
                    <div>Measurements Available Regardless of Fish Species</div>
                  </div>
                </div>
                <div className={'row right'}>
                  <div>
                    <img src={require('../../assets/img/kickstarter/halasz_fishing_ico_tournament.png')} alt={''} />
                  </div>
                  <div className={'features'}>
                    <div className={'features-title'}>ONLINE FISHING TOURNAMNET</div>
                    <div>Anybody can open and participate Anytime, Anywhere</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container_" style={{ paddingTop: '20px', paddingBottom: '20px', backgroundColor: '#F4F4F4' }}>
            <div className={'title center'}>RECOMMENDATION</div>
            <div className={'container'}>
              <div className="row align-items-center right">
                <div className={'col-lg-4 features center'}>
                  <img src={require('../../assets/img/kickstarter/halasz_fishing_img01.png')} alt={''} />
                  <div className={'features-title '}>Anglers who enjoys fishing Freshwater, Saltwater</div>
                  <div>Anglers fishing in freshwater, saltwater can use to measure the weight and the length of their caught fish</div>
                </div>
                <div className={'col-lg-4 features center'}>
                  <img src={require('../../assets/img/kickstarter/halasz_fishing_img02.png')} alt={''} />
                  <div className={'features-title '}>Anglers who wants to brag about their caught fish</div>
                  <div>
                    Use HALASZ APP to take photo and upload. Not only measurements but also fishing information displayed photo will
                    automatically enter the information.
                  </div>
                </div>
                <div className={'col-lg-4 features center'}>
                  <img src={require('../../assets/img/kickstarter/halasz_fishing_img03.png')} alt={''} />
                  <div className={'features-title'}>Fishing Tournament organizers</div>
                  <div>
                    Organizers that opens, held, operates fishing tournaments can use Online Fishing Tournament content in HALASZ APP
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default Kickstarter;
